import downloadPDF from "@/mixins/downloadPDF";
import { mapGetters } from "vuex";
import missionService from "@/services/mission";
import Utils from "@/mixins/Utils";
import conditionHelper from "@/helpers/condition";

export default {
  mixins: [downloadPDF, Utils],
  props: ["limit"],

  data: () => ({
    missions: [],
    errorMission: false,
    showGoogleMap: true,
    googleApiKey: window.configs && window.configs.VUE_APP_GOOGLE_API_KEY !== "" 
    ? window.configs.VUE_APP_GOOGLE_API_KEY: process.env.VUE_APP_GOOGLE_API_KEY,
    noInformation: "Non renseigné",
  }),
  computed: {
    ...mapGetters({
      spinnerMission: "isLoading",
    }),
    permission() {
      return conditionHelper('rcfbusinesssupport');
    }
  },

  async created() {
    await this.missionEnCours();
  },
  methods: {
    loadContact(pkClient) {
      const vue = this;
      const i = vue.missions.findIndex((m) => m.pkClient === pkClient);
      if (i !== -1) {
        vue.missions[i].contactLoading = true;
        missionService
          .loadContact(pkClient)
          .then((res) => {
            if (res.success) {
              vue.missions[i].contactList = res.data.map((m) => {
                m.displayedPhone = vue.getPhoneNumber(m);
                return m;
              });
            } else {
              vue.missions[i].contactError = true;
            }
            vue.missions[i].contactLoaded = true;
          })
          .catch((err) => {
            vue.callToaster(vue.$t('problem-arise'));
            vue.missions[i].contactLoaded = true;
            vue.missions[i].contactError = true;
          })
          .finally(() => {
            vue.missions[i].contactLoading = false;
          });
      }
    },
    async missionEnCours() {
      const vue = this;
      await missionService
        .getMissionEnCours()
        .then((res) => {
          if (res.success) {
            vue.missions = res.data.map((m) => {
              m.contactLoaded = false;
              m.contactLoading = false;
              m.contactError = false;
              m.displayedPhone = vue.getPhoneNumber(m);
              return m;
            });
            vue.errorMission = false;
            return;
          }
          vue.missions = [];
          vue.errorMission = true;
        })
        .catch((err) => {
          vue.missions = [];
          vue.errorMission = true;
        });
    },
    getPhoneNumber(ct) {
      return (
        ct.telAntenne ||
        ct.telPro ||
        ct.mobilePro ||
        ct.telPrivate ||
        ct.mobilePrivate ||
        this.$t('no-information-mobile')
      );
    },
    getStaticMapURL(mission) {
      return `https://maps.google.com/maps/api/staticmap?
        center=${mission.lat},${mission.lng}
        &size=365x256&scale=1&sensor=false&zoom=16
        &markers=${mission.lat}%2C${mission.lng}
        &key=${this.googleApiKey}`;
    },
    getDescriptionSheets(pathologies){
      pathologies = pathologies.map(item => item.pkPathology).join(',') || "";
      this.$router.push({ name: "employee-support-business", query: { pathologies } });
    }
  },
};
